import base from '../modules/base.js'
export default [
	// {path: '/',name:'workbench', component:base.workbench},
	//404界面 
	// {path: '/404.xhtml',name:'notFound', component:base.notFound, meta:{type: 'login'}},
	//工作台
	{path: '/wechatBind.xhtml',name:'workbench', component:base.workbench},

	//登录页面
	// {path: '/login.xhtml',name:'login', component:base.login},

	// //选择企业页面
	// {path: '/wechat/chooseCompany.xhtml',name:'chooseCompany', component:base.chooseCompany},

	// //绑定成功页面
	// {path: '/wechat/bindSucces.xhtml',name:'bindSucces', component:base.bindSucces},
	// //解绑页面
	// {path: '/wechat/unbindWx.xhtml',name:'unbindWx', component:base.unbindWx},
	//绑定信息
	{path: '/wechat/bindInfo.xhtml',name:'bindInfo', component:base.bindInfo},
	
] 